import {
  Mic2,
  HandHeart,
  Globe2,
  Music2,
  Users,
  Sparkles,
  Church,
  HeartHandshake,
  Baby,
  UsersRound,
  BookOpenCheck,
  Coffee,
} from "lucide-react";

// Each ministry tuple now carries [Icon, title, body, image] — the image is
// rendered as a full-bleed background behind the card with a dark overlay.
export const RADIO_MINISTRIES = [
  {
    Icon: Mic2,
    title: "Gospel Broadcasting Ministry",
    body:
      "Sharing the love, hope, and truth of Jesus Christ through radio, online streaming, and digital media.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/hgwlyzzu_Gospel%20Broadcasting%20Ministry.jpg",
  },
  {
    Icon: HandHeart,
    title: "Prayer & Encouragement Ministry",
    body:
      "Standing with individuals and families through prayer, counselling, and words of hope and faith.",
    // Premium dark-tone Unsplash photo — silhouetted hands praying.
    image:
      "https://images.unsplash.com/photo-1499209974431-9dddcece7f88?auto=format&fit=crop&w=1600&q=70",
  },
  {
    Icon: Globe2,
    title: "Multi-Ethnic Outreach Ministry",
    body:
      "Reaching people from every culture and language with God's love and the message of salvation.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/nxjrmeue_Multi%20ethnic%20outreach%20ministry.jpg",
  },
  {
    Icon: Music2,
    title: "Worship & Media Ministry",
    body:
      "Using worship, testimonies, music, and creative media to glorify God and touch lives.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/dlubmr1i_Worship%20%26%20Media%20Ministry.jpg",
  },
  {
    Icon: Users,
    title: "Youth & Family Ministry",
    body:
      "Encouraging the next generation and strengthening families through faith and fellowship.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/4cc9e9t5_Youth%20and%20family%20ministry.jpg",
  },
  {
    Icon: Sparkles,
    title: "Evangelism & Missions Ministry",
    body:
      "Taking the Gospel beyond walls and into communities, homes, and nations.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/yjz28187_Evangelism%20%26%20Missions%20Ministry.jpg",
  },
];

export const CHURCH_MINISTRIES = [
  {
    Icon: Church,
    title: "Worship & Prayer Ministry",
    body:
      "Creating a place where people can encounter God through worship, prayer, and His Word.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/3tfnfkms_Worship%20%26%20Prayer%20Ministry.jpg",
  },
  {
    Icon: HeartHandshake,
    title: "Evangelism & Outreach Ministry",
    body:
      "Sharing the love of Jesus with the local community through compassion and Gospel outreach.",
    // Premium dark-tone Unsplash photo — hands reaching together.
    image:
      "https://images.unsplash.com/photo-1469571486292-0ba58a3f068b?auto=format&fit=crop&w=1600&q=70",
  },
  {
    Icon: Baby,
    title: "Children & Youth Ministry",
    body:
      "Raising young hearts to know, love, and follow Jesus Christ.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/llvpx8fg_children%20and%20youth%20ministry.jpg",
  },
  {
    Icon: UsersRound,
    title: "Men's & Women's Fellowship Ministry",
    body:
      "Building strong, faith-filled lives through encouragement, unity, and spiritual growth.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/wh8z6392_men%27s%20and%20women%27s%20felowship%20ministry.jpg",
  },
  {
    Icon: BookOpenCheck,
    title: "Discipleship & Bible Study Ministry",
    body:
      "Helping believers grow deeper in faith and walk closely with God.",
    // Premium dark-tone Unsplash photo — open Bible by candle light.
    image:
      "https://images.unsplash.com/photo-1504052434569-70ad5836ab65?auto=format&fit=crop&w=1600&q=70",
  },
  {
    Icon: Coffee,
    title: "Hospitality & Care Ministry",
    body:
      "Welcoming people with love, care, and the heart of Christ.",
    image:
      "https://customer-assets.emergentagent.com/job_life-talk-radio/artifacts/egocf7g5_Hospitality%20%26%20Care%20Ministry.jpg",
  },
];
